import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/valve-icon.png';
import _imports_1 from '@/assets/img/icon19.png';
import _imports_2 from '@/assets/img/icon3.png';
import _imports_3 from '@/assets/img/icon4.png';
import _imports_4 from '@/assets/img/icon2.png';
import _imports_5 from '@/assets/img/icon1.png';
import _imports_6 from '@/assets/img/icon5.png';
import _imports_7 from '@/assets/img/icon13.png';
import _imports_8 from '@/assets/img/icon18.png';
import _imports_9 from '@/assets/img/icon14.png';
import _imports_10 from '@/assets/img/icon15.png';
const _withScopeId = n => (_pushScopeId("data-v-b9264868"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "real-time-container"
};
const _hoisted_2 = {
  class: "valve-section"
};
const _hoisted_3 = {
  class: "valve-status-box"
};
const _hoisted_4 = {
  class: "valve-status-row"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "status-label"
}, "阀门状态:", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "valve-icon-container"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "阀门",
  class: "valve-main-icon"
})], -1));
const _hoisted_7 = {
  class: "data-card data-card1"
};
const _hoisted_8 = {
  class: "data-card-inner"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-circle",
  src: _imports_1
}, null, -1));
const _hoisted_10 = {
  class: "data-value"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "data-label"
}, "壳内温度", -1));
const _hoisted_12 = {
  class: "data-grid"
};
const _hoisted_13 = {
  class: "data-card"
};
const _hoisted_14 = {
  class: "data-card-inner"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-circle",
  src: _imports_2
}, null, -1));
const _hoisted_16 = {
  class: "data-value"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "data-label"
}, "气瓶压力", -1));
const _hoisted_18 = {
  class: "data-card"
};
const _hoisted_19 = {
  class: "data-card-inner"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-circle",
  src: _imports_3
}, null, -1));
const _hoisted_21 = {
  class: "data-value"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "data-label"
}, "气瓶剩余次数", -1));
const _hoisted_23 = {
  class: "data-card"
};
const _hoisted_24 = {
  class: "data-card-inner"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-circle",
  src: _imports_4
}, null, -1));
const _hoisted_26 = {
  class: "data-value"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "data-label"
}, "电池电量", -1));
const _hoisted_28 = {
  class: "data-card"
};
const _hoisted_29 = {
  class: "data-card-inner"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-circle",
  src: _imports_5
}, null, -1));
const _hoisted_31 = {
  class: "data-value"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "data-label"
}, "内部电池电压", -1));
const _hoisted_33 = {
  class: "data-card"
};
const _hoisted_34 = {
  class: "data-card-inner"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-circle",
  src: _imports_5
}, null, -1));
const _hoisted_36 = {
  class: "data-value"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "data-label"
}, "外部电池电压", -1));
const _hoisted_38 = {
  class: "data-card"
};
const _hoisted_39 = {
  class: "data-card-inner"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-circle",
  src: _imports_6
}, null, -1));
const _hoisted_41 = {
  class: "data-value"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "data-label"
}, "前置管道压力", -1));
const _hoisted_43 = {
  class: "data-card"
};
const _hoisted_44 = {
  class: "data-card-inner"
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-circle",
  src: _imports_6
}, null, -1));
const _hoisted_46 = {
  class: "data-value"
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "data-label"
}, "后置管道压力", -1));
const _hoisted_48 = {
  class: "data-card"
};
const _hoisted_49 = {
  class: "data-card-inner"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-circle",
  src: _imports_7
}, null, -1));
const _hoisted_51 = {
  class: "data-value"
};
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "data-label"
}, "设备重启次数", -1));
const _hoisted_53 = {
  class: "data-card"
};
const _hoisted_54 = {
  class: "data-card-inner"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-circle",
  src: _imports_8
}, null, -1));
const _hoisted_56 = {
  class: "data-value"
};
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "data-label"
}, "井内湿度", -1));
const _hoisted_58 = {
  class: "data-card"
};
const _hoisted_59 = {
  class: "data-card-inner"
};
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-circle",
  src: _imports_9
}, null, -1));
const _hoisted_61 = {
  class: "data-value"
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "data-label"
}, "气体浓度", -1));
const _hoisted_63 = {
  class: "data-card"
};
const _hoisted_64 = {
  class: "data-card-inner"
};
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-circle",
  src: _imports_10
}, null, -1));
const _hoisted_66 = {
  class: "data-value"
};
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "data-label"
}, "水位高度", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Histogram = _resolveComponent("Histogram");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_actuator_state_history = _resolveComponent("actuator-state-history");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", {
    class: _normalizeClass(["status-value", {
      'status-abnormal': $setup.isValveAbnormal
    }])
  }, _toDisplayString(_ctx.runData.valuePosDesc), 3)]), _hoisted_6]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.runData.temp == null ? '-' : _ctx.runData.temp) + "℃", 1), _hoisted_11])]), _createVNode(_component_el_tooltip, {
    effect: "dark",
    content: "历史数据",
    placement: "top-start"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "historyLine",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.showDetailDialog('temp', '°C', '壳内温度'))
    }, {
      default: _withCtx(() => [_createVNode(_component_Histogram)]),
      _: 1
    })]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.runData.bottlePressure == null ? '-' : _ctx.runData.bottlePressure) + "MPa", 1), _hoisted_17])]), _createVNode(_component_el_tooltip, {
    effect: "dark",
    content: "历史数据",
    placement: "top-start"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "historyLine",
      onClick: _cache[1] || (_cache[1] = $event => _ctx.showDetailDialog('bottlePressure', 'MPa', '气瓶压力'))
    }, {
      default: _withCtx(() => [_createVNode(_component_Histogram)]),
      _: 1
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.runData.bottleNumber == null ? '-' : _ctx.runData.bottleNumber) + "次", 1), _hoisted_22])]), _createVNode(_component_el_tooltip, {
    effect: "dark",
    content: "历史数据",
    placement: "top-start"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "historyLine",
      onClick: _cache[2] || (_cache[2] = $event => _ctx.showDetailDialog('bottleNumber', '次', '气瓶剩余次数'))
    }, {
      default: _withCtx(() => [_createVNode(_component_Histogram)]),
      _: 1
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.runData.batLevel == null ? '-' : _ctx.runData.batLevel) + "%", 1), _hoisted_27])]), _createVNode(_component_el_tooltip, {
    effect: "dark",
    content: "历史数据",
    placement: "top-start"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "historyLine",
      onClick: _cache[3] || (_cache[3] = $event => _ctx.showDetailDialog('batLevel', '%', '电池电量'))
    }, {
      default: _withCtx(() => [_createVNode(_component_Histogram)]),
      _: 1
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_hoisted_30, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.runData.internBatVol == null ? '-' : _ctx.runData.internBatVol) + "mV", 1), _hoisted_32])]), _createVNode(_component_el_tooltip, {
    effect: "dark",
    content: "历史数据",
    placement: "top-start"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "historyLine",
      onClick: _cache[4] || (_cache[4] = $event => _ctx.showDetailDialog('internBatVol', 'mV', '内部电池电压'))
    }, {
      default: _withCtx(() => [_createVNode(_component_Histogram)]),
      _: 1
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_hoisted_35, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.runData.externalBatVol == null ? '-' : _ctx.runData.externalBatVol) + "mV", 1), _hoisted_37])]), _createVNode(_component_el_tooltip, {
    effect: "dark",
    content: "历史数据",
    placement: "top-start"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "historyLine",
      onClick: _cache[5] || (_cache[5] = $event => _ctx.showDetailDialog('externalBatVol', 'mV', '外部电池电压'))
    }, {
      default: _withCtx(() => [_createVNode(_component_Histogram)]),
      _: 1
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_hoisted_40, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.runData.prePipePre == null ? '-' : _ctx.runData.prePipePre) + "kPa", 1), _hoisted_42])]), _createVNode(_component_el_tooltip, {
    effect: "dark",
    content: "历史数据",
    placement: "top-start"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "historyLine",
      onClick: _cache[6] || (_cache[6] = $event => _ctx.showDetailDialog('prePipePre', 'kPa', '前置管道压力'))
    }, {
      default: _withCtx(() => [_createVNode(_component_Histogram)]),
      _: 1
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_hoisted_45, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.runData.postPipePre == null ? '-' : _ctx.runData.postPipePre) + "kPa", 1), _hoisted_47])]), _createVNode(_component_el_tooltip, {
    effect: "dark",
    content: "历史数据",
    placement: "top-start"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "historyLine",
      onClick: _cache[7] || (_cache[7] = $event => _ctx.showDetailDialog('postPipePre', 'kPa', '后置管道压力'))
    }, {
      default: _withCtx(() => [_createVNode(_component_Histogram)]),
      _: 1
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_hoisted_50, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.runData.rebootCnt == null ? '-' : _ctx.runData.rebootCnt) + "次", 1), _hoisted_52])]), _createVNode(_component_el_tooltip, {
    effect: "dark",
    content: "历史数据",
    placement: "top-start"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "historyLine",
      onClick: _cache[8] || (_cache[8] = $event => _ctx.showDetailDialog('rebootCnt', '次', '设备重启次数'))
    }, {
      default: _withCtx(() => [_createVNode(_component_Histogram)]),
      _: 1
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_hoisted_55, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.runData.humidity == null ? '-' : _ctx.runData.humidity) + "%RH", 1), _hoisted_57])]), _createVNode(_component_el_tooltip, {
    effect: "dark",
    content: "历史数据",
    placement: "top-start"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "historyLine",
      onClick: _cache[9] || (_cache[9] = $event => _ctx.showDetailDialog('humidity', '%RH', '井内湿度'))
    }, {
      default: _withCtx(() => [_createVNode(_component_Histogram)]),
      _: 1
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_hoisted_60, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.runData.gasConc == null ? '-' : _ctx.runData.gasConc) + "%LEL", 1), _hoisted_62])]), _createVNode(_component_el_tooltip, {
    effect: "dark",
    content: "历史数据",
    placement: "top-start"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "historyLine",
      onClick: _cache[10] || (_cache[10] = $event => _ctx.showDetailDialog('gasConc', '%LEL', '气体浓度'))
    }, {
      default: _withCtx(() => [_createVNode(_component_Histogram)]),
      _: 1
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_hoisted_65, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.runData.waterLevel == null ? '-' : _ctx.runData.waterLevel) + "cm", 1), _hoisted_67])]), _createVNode(_component_el_tooltip, {
    effect: "dark",
    content: "历史数据",
    placement: "top-start"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "historyLine",
      onClick: _cache[11] || (_cache[11] = $event => _ctx.showDetailDialog('waterLevel', 'cm', '水位高度'))
    }, {
      default: _withCtx(() => [_createVNode(_component_Histogram)]),
      _: 1
    })]),
    _: 1
  })])]), _createVNode(_component_actuator_state_history, {
    ref: "zxqShowHistory"
  }, null, 512)]);
}